import React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeGrid } from "react-window";
import PropTypes from "prop-types";
import clsx from "clsx";

const InfiniteGrid = ({
  listRef,
  outerRef,
  rowSize,
  rowCount,
  columnSize,
  columnCount,
  onScroll,
  renderRow,
  hiddenScrollbar,
}) => (
  <AutoSizer defaultWidth={100} defaultHeight={100} className="auto-sizer">
    {({ height, width }) => {
      const effectiveWidth =
        rowSize * rowCount > height && !hiddenScrollbar ? width - 7 : width;
      return (
        <FixedSizeGrid
          className={clsx(hiddenScrollbar && "hidden_scrollbar")}
          ref={listRef}
          outerRef={outerRef}
          height={height || 100}
          width={width || 100}
          onScroll={({ scrollLeft, scrollTop }) => {
            if (onScroll) {
              onScroll(scrollLeft, scrollTop);
            }
          }}
          columnCount={columnCount}
          columnWidth={columnSize || effectiveWidth || 100}
          rowCount={rowCount}
          rowHeight={rowSize}
        >
          {renderRow}
        </FixedSizeGrid>
      );
    }}
  </AutoSizer>
);

export default InfiniteGrid;

InfiniteGrid.defaultProps = {
  hiddenScrollbar: false,
};

InfiniteGrid.propTypes = {
  listRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // An object
    PropTypes.object,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  outerRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  rowSize: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  columnSize: PropTypes.number,
  columnCount: PropTypes.number.isRequired,
  onScroll: PropTypes.func,
  renderRow: PropTypes.func.isRequired,
  hiddenScrollbar: PropTypes.bool,
};
